import { render, staticRenderFns } from "./PromoPlanCellRenderer.vue?vue&type=template&id=2ebaff2c&scoped=true&"
import script from "./PromoPlanCellRenderer.vue?vue&type=script&lang=js&"
export * from "./PromoPlanCellRenderer.vue?vue&type=script&lang=js&"
import style0 from "./PromoPlanCellRenderer.vue?vue&type=style&index=0&id=2ebaff2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebaff2c",
  null
  
)

export default component.exports